import { render, staticRenderFns } from "./ReportCustomizer.vue?vue&type=template&id=3fa67a68&scoped=true&"
import script from "./ReportCustomizer.vue?vue&type=script&lang=js&"
export * from "./ReportCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./ReportCustomizer.vue?vue&type=style&index=0&id=3fa67a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa67a68",
  null
  
)

export default component.exports